import { RouterModule } from "@angular/router";
import { authGuard } from "../routing";

export const routing = RouterModule.forChild([
    // Organization routes
    {
        path: "org",
        loadChildren: () =>
            import("app/features/organization/organization.module").then(m => m.OrganizationModule),
        canActivate: [authGuard],
        data: {
            requiresAuth: true
        }
    },

    // Applications routes
    {
        path: "apps",
        loadChildren: () =>
            import("app/features/application/application.module").then(m => m.ApplicationModule)
    },

    // Settings routes
    {
        path: "settings",
        loadChildren: () =>
            import("app/features/settings/settings.module").then(m => m.SettingsModule),
        canActivate: [authGuard],
        data: {
            requiresAuth: true
        }
    },

    // Recordings routes
    {
        path: "apps/:app_id/issues/:issue_id",
        loadChildren: () =>
            import("app/features/recording/recording.module").then(m => m.RecordingModule),
        canActivate: [authGuard],
        data: {
            requiresAuth: true
        }
    },
    {
        path: "issue/:share_key",
        loadChildren: () =>
            import("app/features/recording/recording.module").then(m => m.RecordingModule)
    }
]);
